/**
 * Created by mh on 2017/5/24.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { Switch, Redirect, Route } from 'react-router-dom';

import NavigationLeftComponent from './NavigationLeft';
import ChannelsComponent from './Channels';
import ChannelCalendarComponent from './ChannelCalendar';
import ChannelTimelinesComponent from './ChannelTimelines';
import ChannelTimelineDetailComponent from './ChannelTimelineDetails';

import PrivateRoute from '../PrivateRoute.jsx';

@observer
class App extends React.Component {
    render() {
        const { match } = this.props;
        return (
            <div className="row">
                <NavigationLeftComponent />

                <main className="col-sm-9 ml-sm-auto col-md-10 pt-3" role="main">
                    <Switch>
                        <PrivateRoute exact path={`${match.path}/`} component={ChannelsComponent} />
                        <PrivateRoute exact path={`${match.path}/:page`} component={ChannelsComponent} />
                        <PrivateRoute
                            exact
                            path={`${match.path}/details/:id/timelines/details/:timelineId/`}
                            component={ChannelTimelineDetailComponent} />
                        <PrivateRoute path={`${match.path}/details/:id/calendar/:date`} component={ChannelCalendarComponent} />
                        <PrivateRoute path={`${match.path}/details/:id/calendar/`} component={ChannelCalendarComponent} />
                        <PrivateRoute path={`${match.path}/details/:id/timelines/:page`} component={ChannelTimelinesComponent} />
                        <PrivateRoute path={`${match.path}/details/:id/timelines/`} component={ChannelTimelinesComponent} />
                        <PrivateRoute path={`${match.path}/details/:id/`} component={ChannelCalendarComponent} />
                        <Route render={() => <Redirect to={`${match.path}/`} />} />
                    </Switch>
                </main>
            </div>
        );
    }
}

// TODO why not wrappedComponent ?
App.propTypes = {
    match: PropTypes.object.isRequired,
};

export default injectIntl(App);
